/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The OrderCreateOrderItemParam model module.
 * @module model/OrderCreateOrderItemParam
 * @version 1.0
 */
class OrderCreateOrderItemParam {
    /**
     * Constructs a new <code>OrderCreateOrderItemParam</code>.
     * @alias module:model/OrderCreateOrderItemParam
     */
    constructor() { 
        
        OrderCreateOrderItemParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OrderCreateOrderItemParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrderCreateOrderItemParam} obj Optional instance to populate.
     * @return {module:model/OrderCreateOrderItemParam} The populated <code>OrderCreateOrderItemParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrderCreateOrderItemParam();

            if (data.hasOwnProperty('itemId')) {
                obj['itemId'] = ApiClient.convertToType(data['itemId'], 'Number');
            }
            if (data.hasOwnProperty('quantity')) {
                obj['quantity'] = ApiClient.convertToType(data['quantity'], 'Number');
            }
            if (data.hasOwnProperty('revisedQuantity')) {
                obj['revisedQuantity'] = ApiClient.convertToType(data['revisedQuantity'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} itemId
 */
OrderCreateOrderItemParam.prototype['itemId'] = undefined;

/**
 * @member {Number} quantity
 */
OrderCreateOrderItemParam.prototype['quantity'] = undefined;

/**
 * @member {Number} revisedQuantity
 */
OrderCreateOrderItemParam.prototype['revisedQuantity'] = undefined;






export default OrderCreateOrderItemParam;

